import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=9145463a&scoped=true"
import script from "./Shipping.vue?vue&type=script&lang=js"
export * from "./Shipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9145463a",
  null
  
)

export default component.exports